import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleImageSpecification extends FlexibleBaseSpecification {
	id: number;
	imageUrl: string;
	altText: string;
	imageHeight: number;
	imageWidth: number;
}

export class FlexibleImageModel extends FlexibleModelBase {
	public readonly imageUrl: string;
	public readonly altText: string;
	public readonly imageHeight: number;
	public readonly imageWidth: number;

	constructor(spec: FlexibleImageSpecification) {
		super(spec);

		this.imageUrl = spec.imageUrl;
		this.altText = spec.altText;
		this.imageHeight = spec.imageHeight;
		this.imageWidth = spec.imageWidth;
	}
}
